import { createApp } from 'vue';
import Vuelidate from '@vuelidate/core';
// import VueScrollTo from 'vue-scrollto';
import 'bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css';
import VueGtag from 'vue-gtag-next';
// import VCalendar from 'v-calendar';
import App from './App.vue';
import axios from './plugins/axios';
// import './registerServiceWorker';
import router from './router';
import store from './store';

const app = createApp(App);
app.config.globalProperties.axios = axios;
// 画像URLをbackground-image/srcで安全に使うためのエンコード（ファイル名の括弧・空白等対策）
// encodeURIは括弧を変換しないため、CSSのurl()対策で () も明示的にエンコードする
app.config.globalProperties.$mediaUrl = (url) => {
  if (!url) return '';
  return encodeURI(url).replace(/\(/g, '%28').replace(/\)/g, '%29');
};
app.use(store);
app.use(router);
app.use(Vuelidate);
// app.use(VueScrollTo);
app.use(VueGtag, {
  property: {
    id: 'GTM-TVFRLVF',
    router,
  },
});
// app.use(VCalendar, {});
app.mount('#app');
